import {baseSplitApi} from '@/services';
import {Brand} from '../types';

const brandApi = baseSplitApi.injectEndpoints({
  endpoints: builder => ({
    getBrandList: builder.query<Brand[], Record<string, any>>({
      query: params => ({
        url: '/v1/brand',
        method: 'GET',
        params,
      }),
      serializeQueryArgs: ({endpointName, queryArgs, endpointDefinition}) => {
        return endpointName;
      },
      merge: (currentCache, newItems, {arg}) => {
        if (arg.page == 1) {
          currentCache.length = 0;
          currentCache.push(...newItems);
        } else {
          currentCache.push(...newItems);
        }
      },
      forceRefetch({currentArg, previousArg}) {
        return (
          currentArg !== previousArg ||
          (currentArg?.page == 1 && !currentArg.name)
        );
      },
      transformErrorResponse: (
        response: {status: string | number},
        meta,
        arg,
      ) => response.status,
      transformResponse: (response: {data: Brand[]}, meta, arg) =>
        response.data,
    }),
    getBrandById: builder.query<Brand, {brandId: string}>({
      query: args => ({
        url: '/v1/brand/' + args.brandId,
        method: 'GET',
      }),
      transformErrorResponse: (
        response: {status: string | number},
        meta,
        arg,
      ) => response.status,
      transformResponse: (response: {data: Brand}, meta, arg) => response.data,
    }),
  }),
});

export const {
  useGetBrandListQuery,
  useGetBrandByIdQuery,
  useLazyGetBrandByIdQuery,
  useLazyGetBrandListQuery,
} = brandApi;
